/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createModal } from 'react-modal-promise';
import LoadingOverlay from 'components/LoadingOverlay';
import DraggableList from 'components/DraggableList';
import { Button } from 'semantic-ui-react';
import '../ReactModal/reactModal.scss';

function BundleModal(props) {
  const { actions, pen, dealer, close, condition, financeType } = props;

  const bundles = dealer.penConfig.bundles[condition][financeType];
  const [tempBundles, setBundles] = useState([...bundles]);
  const [isLoading, setLoading] = useState(false);

  const saveOrder = async () => {
    setLoading(true);
    const newDealer = {
      id: dealer.id,
      penConfig: {
        bundles: {
          [condition]: {
            [financeType]: tempBundles,
          },
        },
      },
    };

    await actions.updateDealerRequest({
      dealer: newDealer,
      isDiffObject: true,
    });
    close(false);
  };

  const onChange = (newBundles) => {
    setBundles(newBundles);
  };

  const columns = [
    {
      displayName: 'Name',
      format(bundle) {
        return bundle.name;
      },
    },
    {
      displayName: 'Products',
      format(bundle) {
        if (bundle.productIds && bundle.productIds.length) {
          return bundle.productIds
            .map((id) => pen.penConfig.productMap?.[id]?.displayName)
            .join(', ');
        }
        return '';
      },
    },
    {
      displayName: 'Enabled',
      format(bundle) {
        return bundle.enabled ? 'Enabled' : 'Disabled';
      },
    },
  ];

  return (
    <div className="p-modal-container">
      <div className="p-modal large">
        <LoadingOverlay active={isLoading}>
          <div className="p-modal-text flex flex-col items-center">
            <h2>Change bundle order</h2>
            <strong style={{ fontSize: '14px' }}>
              This changes the order users will see that protection plan
              bundles.
            </strong>
            <p style={{ fontSize: '14px' }}>
              Drag and drop the bundles to the desired location and save to
              apply changes.
            </p>
          </div>
          <i
            onClick={() => close(false)}
            className="modal-close close icon"
            alt="close"
          />
          <div className="p-modal-body flex flex-col items-center">
            <DraggableList
              columns={columns}
              width={'60%'}
              data={bundles}
              onChange={onChange}
            />
            <Button onClick={saveOrder}>Save Order</Button>
          </div>
        </LoadingOverlay>
      </div>
    </div>
  );
}

BundleModal.propTypes = {
  close: PropTypes.func,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  pen: PropTypes.object,
  condition: PropTypes.string,
  financeType: PropTypes.string,
};

const mapStateToProps = ({ pen }) => ({
  pen,
});

const ModifyBundleOrder = createModal(connect(mapStateToProps)(BundleModal));

export default ModifyBundleOrder;
